/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Observable, Subscription, of } from 'rxjs';
import { ISelectCategoryFacade, SELECT_CATEGORY_FACADE_TOKEN } from '../../../../../data-access/src/lib/domain/facades-models/select-category-facade-interface';
import { SystemState } from '../../models/system-state';

@Component({
  selector: 'sysque-select-category',
  templateUrl: './select-category.component.html',
  standalone: false
})
export class SelectCategoryComponent implements OnInit, OnDestroy {
  @Input() selectedCategory: string ;
  @Input()categories$: Observable<any[]>;
  @Output() valueChanged: EventEmitter<any> = new EventEmitter<any>();

  public disabled = false;
  public key = "tabName";
  public showClearButton = false;
  public placeholder = "Categories";
  public isManageMode$: Observable<boolean>;
  public width = "305px";
  public height = "30px";
  public className = "select-category-box"
  public isManageModeSubscription: Subscription;
  public systemState: SystemState;
 
  constructor(@Inject(SELECT_CATEGORY_FACADE_TOKEN) private selectCategoryFacade: ISelectCategoryFacade) { }

  public ngOnInit(): void {
    this.systemState = this.selectCategoryFacade.getElectricalState();
    this.selectedCategory = this.systemState?.selectedCategory ?? '';
    this.isManageMode$ = this.selectCategoryFacade.selectManageMode();
    this.isManageModeSubscription = this.isManageMode$.subscribe((data) => {
      this.width = data ? "472px" : "305px";
    });
  }

  public onValueChanged(e: any) {
    this.valueChanged.emit(e);
  }

  public ngOnDestroy(): void {
    if (this.isManageModeSubscription) {
      this.isManageModeSubscription.unsubscribe();
    }
  }
}
